/* eslint-disable no-param-reassign */
const ALERT_OPTIONS = {
  confirmButtonText: '确定',
  closeOnClickModal: false,
};
const CONFIRM_OPTIONS = {
  confirmButtonText: '确定',
  cancelButtonText: '取消',
  closeOnClickModal: false,
};
/**
 * 覆写 element-ui $alert，$confirm 方法
 * 提供默认参数，使用时只需传入 message
 */
const Popup = {
  install(Vue) {
    Vue.prototype.$_yh_alert = function alert(message, tip = '提示', options = ALERT_OPTIONS) {
      return this.$alert(message, tip, options);
    };
    Vue.prototype.$_yh_confirm = function confirm(
      message,
      tip = '提示',
      options = CONFIRM_OPTIONS,
    ) {
      return this.$confirm(message, tip, options);
    };
  },
};

export default Popup;
